import HideableController from './hideable_controller';

export default class extends HideableController {
  static targets = ['connected'];

  connect() {
    this.update();
  }

  update() {
    if (this.mayShowDetails()) {
      this.showDetails();
    } else {
      this.hideDetails();
    }
  }

  mayShowDetails() {
    if (this.useCheckboxLogic()) {
      return this.checkboxMayShowDetails();
    } else if (this.useRadioButtonLogic()) {
      return this.radioButtonMayShowDetails();
    } else {
      return this.valueIncluded() || this.showTypes.length === 0;
    }
  }

  checkboxMayShowDetails() {
    if (!this.hasConnectedTarget) return false;

    const checkboxLogic = this.checkBoxLogic;
    if (checkboxLogic == 'checked' && this.connectedTarget.checked) {
      return true;
    }
    if (checkboxLogic == 'unchecked' && !this.connectedTarget.checked) {
      return true;
    }
    return false
   }

   radioButtonMayShowDetails() {
    const radioButtonLogic = this.radioButtonLogic;
    var correctChecked = false;
    this.connectedTargets.forEach((el) => {
      if (el.checked && el.value == radioButtonLogic) {
        correctChecked = true;
      }
    });
    return correctChecked
   }

  valueIncluded() {
    return this.showTypes.includes(this.connectedValue);
  }

  hideDetails() {
    this.hideAll();
    this.disable();
  }

  showDetails() {
    this.enable();
    this.showAll();
  }

  disable() {
    this.elementTargets.forEach((el) => {
      el.setAttribute('disabled', true);
    })
  }

  enable() {
    this.elementTargets.forEach((el) => {
      el.removeAttribute('disabled');
    })
  }

  get showTypes() {
    const types = this.data.get('showTypes');
    if (!types) return [];

    return JSON.parse(types);
  }

  get connectedValue() {
    const { dataset: { query } } = this.connectedTarget;
    if (!query) return this.connectedTarget.value;

    return this.connectedTarget.querySelector(query).value;
  }

  get checkBoxLogic() {
    return this.data.get('checkbox');
  }

  get radioButtonLogic() {
    return this.data.get('radiobutton');
  }

  useCheckboxLogic() {
    if (!this.checkBoxLogic) return false;
    return true;
  }

  useRadioButtonLogic() {
    if (!this.radioButtonLogic) return false;
    return true;
  }
}
